/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import EditItem from "cruds/item-management/edit-item";
import NewCompany from "cruds/company-management/new-company";
import NewEntity from "cruds/entity-management/new-entity";
import NewItem from "cruds/item-management/new-item";
import EditRole from "cruds/role-managament/edit-role";
import NewRole from "cruds/role-managament/new-role";
import EditTag from "cruds/tag-management/edit-tag";
import NewTag from "cruds/tag-management/new-tag";
import EditUser from "cruds/user-management/edit-user";
import NewUser from "cruds/user-management/new-user";
import EditCompany from "cruds/company-management/edit-company";
import EditEntity from "cruds/entity-management/edit-entity";
import NewDevice from "cruds/device-management/internal-device-management/new-device";
import EditDevice from "cruds/device-management/internal-device-management/edit-device";
import ViewEntity from "cruds/entity-management/view-entity";
import NewContact from "cruds/contact-management/new-contact";
import EditContact from "cruds/contact-management/edit-contact";
import NewAPI from "cruds/api-management/new-api";
import EditAPI from "cruds/api-management/edit-api";
import NewMonitorDevice from "cruds/device-management/monitor-management/new-monitor";
import EditMonitorDevice from "cruds/device-management/monitor-management/edit-monitor";
import ViewMonitorDevice from "cruds/device-management/monitor-management/view-monitor";
import NewParameter from "cruds/api/mapping/internal-parameter/new-parameter";
import EditParameter from "cruds/api/mapping/internal-parameter/edit-parameter";
import NewMessage from "cruds/message-management/new-message";
import EditMessage from "cruds/message-management/edit-message";
import ViewDevice from "cruds/device-management/internal-device-management/view-device";
import EditProvider from "cruds/provider-management/edit-provider";
import ServiceRequestDetail from "cruds/device-management/internal-device-management/view-device/service-request-detail";
import NewCampaign from "cruds/campaign/campaigns/create";
import EditCampaign from "cruds/campaign/campaigns/edit";
import NewCampaignCompany from "cruds/campaign/Company/create";
import EditCampaignCompany from "cruds/campaign/Company/edit";
import NewCampaignEvent from "cruds/campaign/events/create";
import EditCampaignEvent from "cruds/campaign/events/edit";
import NewCampaignContact from "cruds/campaign/contacts/create";
import EditCampaignContact from "cruds/campaign/contacts/edit";
import NewPromptTemplate from "cruds/prompt-template/new-message";
import EditPromptTemplate from "cruds/prompt-template/edit-message";
import CreateTemplate from "cruds/campaign/template/create";
import EditTemplate from "cruds/campaign/template/edit";
import NewCampaignAssociation from "cruds/campaign/association/create";
import EditCampaignAssociation from "cruds/campaign/association/edit";
import GeofenceCreate from "cruds/geofence-management/create";
import GeofenceEdit from "cruds/geofence-management/edit";
import NewTemplateRoute from "cruds/route-template/new-template";
import EditTemplateRoute from "cruds/route-template/edit-template";
import NewSubscriptionPlan from "cruds/subscription-plan/new-plan";
import EditSubscriptionPlan from "cruds/subscription-plan/edit-plan";
import EditRequestService from "cruds/servicerequest-management/edit-service";
import EditContactEntity from "cruds/entity-management/contact";
import OnboardingCustomer from "cruds/onboarding/customer";
import AddAddress from "cruds/onboarding/add-address";
import AddContact from "cruds/onboarding/add-contacts";
import AddItems from "cruds/onboarding/add-items";
import AssignDevice from "cruds/onboarding/assign-device";
import OnboardingNotification from "cruds/onboarding/notifications";
import DeviceClaims from "cruds/onboarding/device-claims";
import InstallationHistory from "cruds/onboarding/device-claims/InstallationHistoryPage";
import JobViewPage from "cruds/device-management/internal-device-management/view-device/jobs/JobViewPage.js";

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts

const crudRoutes = [
  {
    key: "new-company",
    route: "/company-management/new-company",
    component: <NewCompany />,
    type: "companies",
  },
  {
    key: "edit-company",
    route: "/company-management/edit-company/:id",
    component: <EditCompany />,
    type: "companies",
  },
  {
    key: "view-entity",
    route: "/entity-management/view-entity/:id",
    component: <ViewEntity />,
    type: "entities",
  },
  {
    key: "new-entity",
    route: "/entity-management/new-entity",
    component: <NewEntity />,
    type: "entities",
  },
  {
    key: "edit-entity",
    route: "/entity-management/edit-entity/:id",
    component: <EditEntity />,
    type: "entities",
  },
  {
    key: "edit-entity-contact",
    route: "/entity-management/edit-entity/contact/:id",
    component: <EditContactEntity />,
    type: "entities",
  },
  {
    key: "edit-entity-contact",
    route: "/entity-management/new-entity/contact",
    component: <EditContactEntity />,
    type: "entities",
  },
  {
    key: "new-tag",
    route: "/tag-management/new-tag",
    component: <NewTag />,
    type: "tags",
  },
  {
    key: "edit-tag",
    route: "/tag-management/edit-tag/:id",
    component: <EditTag />,
    type: "tags",
  },
  {
    key: "new-role",
    route: "/role-management/new-role",
    component: <NewRole />,
    type: "roles",
  },
  {
    key: "edit-role",
    route: "/role-management/edit-role/:id",
    component: <EditRole />,
    type: "roles",
  },
  {
    key: "new-user",
    route: "/user-management/new-user",
    component: <NewUser />,
    type: "users",
  },
  {
    key: "edit-user",
    route: "/user-management/edit-user/:id",
    component: <EditUser />,
    type: "users",
  },
  {
    key: "new-item",
    route: "/item-management/new-item",
    component: <NewItem />,
    type: "items",
  },
  {
    key: "edit-item",
    route: "/item-management/edit-item/:id",
    component: <EditItem />,
    type: "items",
  },
  {
    key: "view-device",
    route: "/devices/view-device/:id",
    component: <ViewDevice />,
    type: "devices",
  },
  {
    key: "new-device",
    route: "/devices/new-device",
    component: <NewDevice />,
    type: "devices",
  },
  {
    key: "edit-device",
    route: "/devices/edit-device/:id",
    component: <EditDevice />,
    type: "devices",
  },
  {
    key: "edit-service-request",
    route: "/service-request/edit/:id",
    component: <EditRequestService />,
    type: "devices",
  },
  {
    key: "new-monitor",
    route: "/monitor-management/new-monitor",
    component: <NewMonitorDevice />,
    type: "monitors",
  },
  {
    key: "view-monitor",
    route: "/monitor-management/view-monitor/:id",
    component: <ViewMonitorDevice />,
    type: "monitors",
  },
  {
    key: "edit-monitor",
    route: "/monitor-management/edit-monitor/:id",
    component: <EditMonitorDevice />,
    type: "monitors",
  },
  {
    key: "edit-campaign",
    route: "/campaign/edit/:id",
    component: <EditCampaign />,
    type: "campaign",
  },
  {
    key: "new-campaign",
    route: "/campaign/new",
    component: <NewCampaign />,
    type: "campaign",
  },
  {
    key: "new-company",
    route: "/campaign/company/new",
    component: <NewCampaignCompany />,
    type: "campaign",
  },
  {
    key: "edit-company",
    route: "/campaign/company/edit/:id",
    component: <EditCampaignCompany />,
    type: "campaign",
  },
  {
    key: "new-event",
    route: "/campaign/event/new",
    component: <NewCampaignEvent />,
    type: "campaign",
  },
  {
    key: "edit-event",
    route: "/campaign/event/edit/:id",
    component: <EditCampaignEvent />,
    type: "campaign",
  },
  {
    key: "new-contact",
    route: "/campaign/contact/new",
    component: <NewCampaignContact />,
    type: "campaign",
  },
  {
    key: "edit-contact",
    route: "/campaign/contact/edit/:id",
    component: <EditCampaignContact />,
    type: "campaign",
  },
  {
    key: "new-template",
    route: "/campaign/template/new",
    component: <CreateTemplate />,
    type: "campaign",
  },
  {
    key: "edit-template",
    route: "/campaign/template/edit/:id",
    component: <EditTemplate />,
    type: "campaign",
  },
  {
    key: "new-association",
    route: "/campaign/association/new",
    component: <NewCampaignAssociation />,
    type: "campaign",
  },
  {
    key: "edit-association",
    route: "/campaign/association/edit/:id",
    component: <EditCampaignAssociation />,
    type: "campaign",
  },
  {
    key: "new-prompt",
    route: "/prompt-template/new-template",
    component: <NewPromptTemplate />,
    type: "prompt",
  },
  {
    key: "edit-prompt",
    route: "/prompt-template/edit-template/:id",
    component: <EditPromptTemplate />,
    type: "prompt",
  },
  {
    key: "new-contact",
    route: "/contact-management/new-contact",
    component: <NewContact />,
    type: "contacts",
  },
  {
    key: "edit-contact",
    route: "/contact-management/edit-contact/:id",
    component: <EditContact />,
    type: "contacts",
  },
  {
    key: "new-contact",
    route: "/geofence-management/new",
    component: <GeofenceCreate />,
    type: "contacts",
  },
  {
    key: "edit-contact",
    route: "/geofence-management/edit/:id",
    component: <GeofenceEdit />,
    type: "contacts",
  },
  {
    key: "new-route-template",
    route: "/route-template/new",
    component: <NewTemplateRoute />,
    type: "contacts",
  },
  {
    key: "subscription-plan",
    route: "/subscription-plan/new",
    component: <NewSubscriptionPlan />,
    type: "subscription-plan",
  },
  {
    key: "edit-route-template",
    route: "/route-template/edit/:id",
    component: <EditTemplateRoute />,
    type: "contacts",
  },
  {
    key: "subscription-plan",
    route: "/subscription-plan/edit/:id",
    component: <EditSubscriptionPlan />,
    type: "subscription-plan",
  },
  {
    key: "new-api",
    route: "/api-management/new-api",
    component: <NewAPI />,
    type: "apis",
  },
  {
    key: "edit-api",
    route: "/api-management/edit-api/:id",
    component: <EditAPI />,
    type: "apis",
  },
  {
    key: "new-internal-parameter",
    route: "/internal-parameter-management/new-parameter",
    component: <NewParameter />,
    type: "parameters",
  },
  {
    key: "edit-internal-parameter",
    route: "/internal-parameter-management/edit-parameter/:id",
    component: <EditParameter />,
    type: "parameters",
  },
  {
    key: "new-message",
    route: "/message-management/new-message",
    component: <NewMessage />,
    type: "messages",
  },
  {
    key: "edit-message",
    route: "/message-management/edit-message/:id",
    component: <EditMessage />,
    type: "messages",
  },
  {
    key: "edit-provider",
    route: "/provider-management/edit-provider/:id",
    component: <EditProvider />,
    type: "providers",
  },
  {
    key: "service-request-detail",
    route: "/service-request-detail/:id",
    component: <ServiceRequestDetail />,
    type: "serviceRequest",
  },
  {
    key: "onboarding",
    route: "/onboarding/customer",
    component: <OnboardingCustomer />,
    type: "onboarding",
  },
  {
    key: "onboarding-add-address",
    route: "/onboarding/add-address",
    component: <AddAddress />,
    type: "onboarding",
  },
  {
    key: "onboarding-add-contacts",
    route: "/onboarding/add-contacts",
    component: <AddContact />,
    type: "onboarding",
  },
  {
    key: "onboarding-add-items",
    route: "/onboarding/add-items",
    component: <AddItems />,
    type: "onboarding",
  },
  {
    key: "onboarding-assign-device",
    route: "/onboarding/assign-device",
    component: <AssignDevice />,
    type: "onboarding",
  },
  {
    key: "onboarding-notification",
    route: "/onboarding/notification",
    component: <OnboardingNotification />,
    type: "onboarding",
  },
  {
    key: "onboarding-device-claims",
    route: "/onboarding/device-claims",
    component: <DeviceClaims />,
    type: "onboarding",
  },
  {
    key: "onboarding-device-claim-summary",
    route: "/onboarding/device-claims/:claimId/summary",
    component: <InstallationHistory />,
    type: "onboarding",
  },
  {
    key: "job-view",
    route: "/job-view/:id",
    component: <JobViewPage />,
    type: "onboarding",
  },

];

export default crudRoutes;
